import * as React from 'react'
import { FC } from 'react'
import IconButton from '@mui/material/IconButton'
import Paper from '@mui/material/Paper'
import Tooltip from '@mui/material/Tooltip'
import Badge from '@mui/material/Badge'
import LayersIcon from '@mui/icons-material/Layers'

type Props = {
  count: number
  onOpen: () => void
}

/**
 * Opens the territory list (WWM-17508, Feature A).
 *
 * Badged with the count so an admin can see at a glance whether the tenant has territories at
 * all -- the polygons are faint by design, and at a zoomed-in view none may be on screen.
 */
export const TerritoryManageButton: FC<Props> = ({ count, onOpen }) => (
  <Tooltip title="Territories" placement="left">
    <Paper elevation={4}>
      <IconButton
        sx={{ p: 1 }}
        onClick={onOpen}
        aria-label={`Territories (${count})`}
        data-test-id="territory-manage-button"
      >
        <Badge badgeContent={count} color="primary" max={99}>
          <LayersIcon fontSize="small" />
        </Badge>
      </IconButton>
    </Paper>
  </Tooltip>
)
